// extracted by mini-css-extract-plugin
export default {"backgroundMedia":"FullWidthMedia_backgroundMedia__2CBwF","wrapper":"FullWidthMedia_wrapper__HcnYY"};